// extracted by mini-css-extract-plugin
export default {"image":"ProjectImage_image__PvYge"};